import type { AppProps } from 'next/app';
import { Router } from 'next/router';
import { useEffect } from 'react';
import { Layout } from '../components/layout/layout.comp';
import { GlobalStyles } from '../styles/styles.config';

const useInterceptNextDataHref = ({
	router,
	namespace,
}: {
	router: Router;
	namespace: string;
}) => {
	useEffect(() => {
		if (router.pageLoader?.getDataHref) {
			const originalGetDataHref = router.pageLoader.getDataHref;
			router.pageLoader.getDataHref = function (...args: any[]) {
				// @ts-ignore
				const r = originalGetDataHref.call(router.pageLoader, ...args);
				return r && r.startsWith('/_next/data') ? `/${namespace}${r}` : r;
			};
		}
	}, [router, namespace]);
};

export default function App({ Component, pageProps, router }: AppProps) {
	useInterceptNextDataHref({
		router,
		namespace: 'discover',
	});
	return (
		<>
			<GlobalStyles />
			<Layout>
				<Component {...pageProps} />
			</Layout>
		</>
	);
}
